import PageHeader from '@/components/page-header'
import PendingModule from '@/components/pending-module'

const ClientesList = () => (
  <>
    <PageHeader title="Clientes" subtitle="Cadastro das empresas que usam o IntegraDoor" />

    <PendingModule
      descricao="O ciclo de cliente é o mais completo que existe hoje na api-backoffice: listar, obter para edição, criar e editar já respondem. Falta migrar para v2 e ligar a tela."
      dependencias={[
        'Listar: GET backoffice/suporte/clientes com ClienteQuery (busca e paginação) — hoje em v1',
        'Obter para edição: GET backoffice/suporte/cliente-edicao/{clienteId}, que devolve cliente, unidades e administrador',
        'Criar: POST backoffice/suporte/nova-empresa, que cria empresa, endereço, unidades, pontos de atendimento, api keys e o admin do cliente numa tacada',
        'Editar: PUT backoffice/suporte/editar-empresa/{clienteId} — atenção, ele apaga e recria unidades e pontos a cada gravação',
        'Migrar os quatro para v2 e para o envelope padrão antes do front tipar em cima',
      ]}
      card="IN-2803"
    />
  </>
)

export default ClientesList
